<template>
  <div class="page-main page-border">
    <div class="page-header">
      <h1 class="page-title">{{ $t("billing.labels.billing") }}</h1>
    </div>
    <div class="page-content">
      <div class="card">
        <div class="card-block" v-show="isLoading">
          <div class="row">
            <div class="col-md-12 card-stat">
              <loading-indicator></loading-indicator>
            </div>
          </div>
        </div>
        <div v-show="!isLoading">
          <Current-stat
            v-if="showCurrentStat"
            v-bind:team="team"
            v-on:loadChanged="currentStatLoadChanged">
          </Current-stat>
          <Payment-section
            v-if="showPaymentSection"
            v-bind:team="team"
            v-bind:showBillingCredit="showBillingCredit"
            v-bind:showBillingInformation="showBillingInformation"
            v-on:loadChanged="paymentSectionLoadChanged">
          </Payment-section>
          <!--Redeem-voucher
            v-if="showRedeemVoucher"
            v-bind:team="team"
            v-on:loadChanged="redeemVoucherLoadChanged">
          </Redeem-voucher-->
          <Monthly-usage-history
            v-if="showMonthlyUsageHistory"
            v-bind:team="team"
            v-on:loadChanged="monthlyUsageHistoryLoadChanged">
          </Monthly-usage-history>
          <Statement
            v-if="showStatement"
            v-bind:team="team"
            v-on:loadChanged="statementLoadChanged">
          </Statement>
          <Client-usage-history
            v-bind:team="team"
            v-bind:showTitle="true"
            v-on:loadChanged="clientUsageHistoryLoadChanged"
            v-if="showClientUsageHistory">
          </Client-usage-history>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueScrollTo from 'vue-scrollto';
import CurrentStat from 'components/billings/CurrentStat';
import PaymentSection from 'components/billings/payments/PaymentSection';
import RedeemVoucher from 'components/billings/RedeemVoucher';
import Statement from 'components/billings/Statement';
import MonthlyUsageHistory from 'components/billings/usages/MonthlyUsageHistory';
import ClientUsageHistory from 'components/billings/usages/ClientUsageHistory';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    CurrentStat,
    PaymentSection,
    RedeemVoucher,
    Statement,
    MonthlyUsageHistory,
    ClientUsageHistory,
    LoadingIndicator,
  },
  watch: {
    isLoading: function(value) {
      if (!value) {
        if (this.$route.hash === '#addcreditSection') {
          this.$nextTick(() => {
            // scroll to add credit section
            VueScrollTo.scrollTo('#addcreditSection');
          });
        } else if (this.$route.hash === '#statementSection') {
          this.$nextTick(() => {
            // scroll to add statement section
            VueScrollTo.scrollTo('#statementSection');
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    isLoading: function() {
      return (
        this.isCurrentStatLoading ||
        this.isPaymentSectionLoading ||
        this.isRedeemVoucherLoading ||
        this.isMonthlyUsageHistoryLoading ||
        this.isStatementLoading ||
        this.isClientUsageHistoryLoading);
    },
  },
  data: function () {
    return {
      showCurrentStat: false,
      showPaymentSection: false,
      showBillingCredit: false,
      showBillingInformation: false,
      showRedeemVoucher: false,
      showMonthlyUsageHistory: false,
      showStatement: false,
      showClientUsageHistory: false,
      team: null,
      isCurrentStatLoading: false,
      isBillingCreditLoading: false,
      isBillingInformationLoading: false,
      isRedeemVoucherLoading: false,
      isMonthlyUsageHistoryLoading: false,
      isStatementLoading: false,
      isClientUsageHistoryLoading: false,
    };
  },
  mounted: function() {
    this.team = this.currentUser.team;

    this.checkVisibleComponents();
  },
  methods: {
    resetVisibleComponents: function() {
      this.showCurrentStat = false;
      this.showPaymentSection = false;
      this.showBillingCredit = false;
      this.showBillingInformation = false;
      this.showRedeemVoucher = false;
      this.showMonthlyUsageHistory = false;
      this.showStatement = false;
      this.showClientUsageHistory = false;
    },
    checkVisibleComponents: function() {
      const isTeamManager = (this.currentUser.role === 'manager');

      if (!this.team.is_reseller && !this.team.has_reseller) {
        this.resetVisibleComponents();

        // team is normal user
        const isPrePaidTeam = (this.team.pay_plan === 'prepaid');

        if (isTeamManager) {
          this.showCurrentStat = true;
          this.showPaymentSection = isPrePaidTeam;
          this.showBillingCredit = Boolean(isPrePaidTeam);
          this.showRedeemVoucher = isPrePaidTeam;
          this.showBillingInformation = true;
          this.showStatement = true;
        }

        this.showMonthlyUsageHistory = true;
      } else if (this.team.is_reseller) {
        this.resetVisibleComponents();

        // team is reseller & user is manager
        if (isTeamManager) {
          this.showBillingInformation = true;
        }

        // team is reseller & user is user
        this.showClientUsageHistory = true;
      } else if (this.team.has_reseller) {
        this.resetVisibleComponents();

        // team is reseller client
        this.showMonthlyUsageHistory = true;
      }
    },
    currentStatLoadChanged: function(value) {
      this.isCurrentStatLoading = value;
    },
    paymentSectionLoadChanged: function(value) {
      this.isPaymentSectionLoading = value;
    },
    redeemVoucherLoadChanged: function(value) {
      this.isRedeemVoucherLoading = value;
    },
    monthlyUsageHistoryLoadChanged: function(value) {
      this.isMonthlyUsageHistoryLoading = value;
    },
    statementLoadChanged: function(value) {
      this.isStatementLoading = value;
    },
    clientUsageHistoryLoadChanged: function(value) {
      this.isClientUsageHistoryLoading = value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// BillingSummary.vue?a6444302